module.exports = __webpack_public_path__ + "static/media/ypic_logo_small.e5c53960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ypic_logo_small.png
// module id = 244
// module chunks = 2